import React from "react";
import SectionContainer from "../../../components/landing/section-container";
import "./frequently-asked-questions.css";
import Question from "../../../components/landing/question";

const questions = [
  {
    question: "¿Qué está incluido en el alquiler?",
    answer:
      "El alquiler cubre agua, electricidad, internet, y limpieza quincenal de áreas comunes. También se proporcionan utensilios de cocina (licuadora, refrigeradora, olla arrocera, olla de presión, tetera, coffee maker, sartenes, ollas, platos, vasos, cubiertos, microondas, plantillas de inducción) y lavandería con lavadora y secadora. Cada cuarto está amoblado con cama, colchón ortopédico, almohadas, sábanas, armario, escritorio y silla.",
  },
  {
    question: "¿Qué tipo de cuartos tienen disponibles?",
    answer: "Tenemos cuartos individuales.",
  },
  {
    question: "¿Cuál es la duración mínima?",
    answer:
      "La duración mínima es de 6 meses. Sin embargo si se comunica con antelación es algo negociable.",
  },
  {
    question: "¿De cuánto es el depósito?",
    answer: "El depósito es el 50% del valor de la mensualidad.",
  },
  {
    question: "¿Cuáles son las opciones de pago?",
    answer: "Puedes pagar mensualmente por SINPE móvil o transferencia.",
  },
  {
    question:
      "¿Existen reglas o políticas que los residentes deban tener en cuenta?",
    answer:
      "Sí. No se permiten mascotas, fumar, acoso ni destruir la propiedad. Cualquier infracción resultará en expulsión.",
  },
  {
    question: "¿Existe área de parqueo?",
    answer: "No",
  },
  {
    question: "¿Se permiten mascotas?",
    answer: "No, no se permiten mascotas.",
  },
  {
    question: "¿Qué debo hacer si quiero cancelar mi contrato?",
    answer:
      "Debe avisar con un mes de antelación. Por ejemplo, si se quiere ir en el cuarto mes, avisa durante el tercer mes.",
  },
  {
    question: "¿Necesito llevar artículos para cocinar?",
    answer:
      "No es necesario. La casa está equipada con todos los electrodomésticos y utensilios de cocina necesarios. Te animamos a no traer nada adicional. Si algo se necesita y no está disponible, nos encargaremos de ello. Esto nos ayudará a mantener un ambiente ordenado.",
  },
  {
    question: "¿Necesito llevar equipo para dormir?",
    answer:
      "Solamente su cobija favorita. Cada cuarto está equipado con colchones ortopédicos, sabanas y se proporcionará una almohada nueva para cada residente. Si necesitas algo específico para dormir, lo puedes traer, pero lo esencial ya está provisto por la casa.",
  },
  {
    question: "¿Puede quedarse alguien a dormir?",
    answer:
      "No, la capacidad de la casa está diseñada para un número específico de personas. En caso muy necesario, por favor hable con los dueños.",
  },
];

function FrequentlyAskedQuestionsPage() {
  return (
    <SectionContainer id="faq" title="Preguntas frecuentes">
      <div>
        {questions.map((value) => {
          return (
            <Question
              question={value.question}
              answer={value.answer}
              key={value.answer}
            />
          );
        })}
      </div>
    </SectionContainer>
  );
}

export default FrequentlyAskedQuestionsPage;
